import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';

import { PROJECT_TYPES } from '../../constants';
import ResponseForm from '../../scout-collect-data/components/response-form/ResponseForm';
import MessagesList from '../../scout-collect-data/components/messages-list/MessagesList';
import Header from '../scout/components/header/Header';
import { requestForHelpConsumer, sendResponseDataConsumer } from '../../redux/consumer/scout/consumerScoutActions';
import { selectConsumerSession } from '../../redux/consumer/consumerSelectors';
import ConsumerLayout from '../consumer-layout/ConsumerLayout';

function ScoutCollectData() {
  const [isShowResponseForm, setIsShowResponseForm] = useState(true);
  const { projectName } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { projectName: storedProjectName, projectPassword: storedProjectPassword } = useSelector(selectConsumerSession);

  const toggleResponseFormVisibility = () => {
    setIsShowResponseForm((prevState) => !prevState);
  };

  const handleSendResponse = async (values) => {
    await dispatch(sendResponseDataConsumer(values));
    navigate(`/${PROJECT_TYPES.SCOUTV2.toLocaleLowerCase()}/${projectName}`);
  };

  const handleRequestForHelp = async (values) => {
    await dispatch(requestForHelpConsumer(values));
    navigate(`/${PROJECT_TYPES.SCOUTV2.toLocaleLowerCase()}/${projectName}`);
  };

  useEffect(() => {
    if (!storedProjectName || !storedProjectPassword) {
      navigate(`/${PROJECT_TYPES.SCOUTV2.toLocaleLowerCase()}/${projectName}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ConsumerLayout Header={Header()}>
      <ResponseForm
        isShowResponseForm={isShowResponseForm}
        toggleResponseFormVisibility={toggleResponseFormVisibility}
        onSendResponse={handleSendResponse}
        onClickForHelp={handleRequestForHelp}
      />

      <MessagesList isShowResponseForm={isShowResponseForm} />
    </ConsumerLayout>
  );
}

export default ScoutCollectData;
